import {Injectable} from '@angular/core';
import {Aktivitet} from './models/aktivitet';
import {environment} from '../environments/environment';
import {Broderkort} from './models/broderkort';
import {AuthHttp} from 'angular2-jwt';
import {Tilldelningar} from './models/tilldelningar';
import {Forlaning, Hclistitem, Pricklistitem} from './models/hc';
import {Brodernamn} from './models/brodernamn';
import {Consmin} from './models/consmin';
import {Grej} from './models/grej';
import {Bestallning} from './models/bestallning';

@Injectable()
export class AktiviteterService {
    tilldelningar: Promise<Tilldelningar>;

    constructor(private http: AuthHttp) {
    }

    getAktiviteter(): Promise<Aktivitet[]> {
        return this.http.get(environment.apiUrl + '/backend/aktiviteter')
            .toPromise()
            .then(response => response.json() as Aktivitet[])
            .catch(reason => {
                if (reason.status) {
                    return Promise.reject(reason);
                } else {
                    console.log(reason);
                }
            });
    }

    getAktivitet(id): Promise<Aktivitet> {
        return this.http.get(environment.apiUrl + '/backend/aktiviteter/' + id)
            .toPromise()
            .then(response => response.json() as Aktivitet);
    }

    getBroderkort(id): Promise<Broderkort> {
        return this.http.get(environment.apiUrl + '/backend/broder/' + id)
            .toPromise()
            .then(response => response.json() as Broderkort);
    }

    getBroderlista(): Promise<Brodernamn[]> {
        return this.http.get(environment.apiUrl + '/backend/broderlista')
            .toPromise()
            .then(response => response.json() as Brodernamn[]);
    }

    getSammanstallning(id: number): Promise<Grej[]> {
        return this.http.get(environment.apiUrl + '/backend/sammanstallning/' + id)
            .toPromise()
            .then(response => response.json() as Grej[]);
    }

    getHclista(id: number): Promise<Hclistitem[]> {
        return this.http.get(environment.apiUrl + '/backend/hclista/' + id)
            .toPromise()
            .then(response => response.json() as Hclistitem[]);
    }

    getPricklista(id: number): Promise<Pricklistitem[]> {
        return this.http.get(environment.apiUrl + '/backend/pricklista/' + id)
            .toPromise()
            .then(response => response.json() as Pricklistitem[]);
    }

    saveConsmin(lista: Consmin[]): void {
        this.http.post(environment.apiUrl + '/backend/consminlista', {listan: lista}).subscribe();
    }

    getTilldelningar(): Promise<Tilldelningar> {
        if (!this.tilldelningar) {
            this.tilldelningar = this.http.get(environment.apiUrl + '/backend/tilldelningar')
                .toPromise()
                .then(response => response.json() as Tilldelningar);
        }
        return this.tilldelningar;
    }

    getHc(aktivitet: number, broder: number): Promise<Forlaning[]> {
        return this.http.get(environment.apiUrl + '/backend/hc?aktiviteter_id=' + aktivitet + '&broder_id=' + broder)
            .toPromise()
            .then(response => response.json() as Forlaning[]);
    }

    setHc(aktivitet: number, broder: number, hc: Forlaning[]): Promise<Forlaning[]> {
        const body = {'aktiviteter_id': aktivitet, 'broder_id': broder, 'hc': hc};
        return this.http.post(environment.apiUrl + '/backend/hc', body)
            .toPromise().then(response => response.json() as Forlaning[]);
    }

    unsetHc(aktivitet: number, broder: number): Promise<Forlaning[]> {
        const body = {'aktiviteter_id': aktivitet, 'broder_id': broder};
        return this.http.post(environment.apiUrl + '/backend/hc', body)
            .toPromise().then(response => response.json() as Forlaning[]);
    }

    getBestallningar(id: number) {
        return this.http.get(environment.apiUrl + '/backend/bestallning/' + id)
            .toPromise()
            .then(response => response.json() as Bestallning);

    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/aktiviteter.service.ts